import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ListItemsModal from './ListItemsModal'
import ItemsModal from './ItemsModal'

import {
  loadItemsICanGetFromOtherUser,
  loadMoreItemsICanGetFromOtherUser,
  unloadItemsICanGetFromOtherUser,
} from '../../actions'
import {
  getItemsICanGetFromOtherUser,
  canLoadMoreItemsICanGetFromOtherUser,
  getTotalItemsICanGetFromOtherUser,
  getItemsICanGetFromOtherUserLoading,
} from '../../selectors'

class ItemsICanGetModalList extends PureComponent {
  componentDidMount() {
    this.props.loadItemsICanGetFromOtherUser({
      swapper_id: this.props.swapperId,
      swap_id: this.props.swapId,
      cat_id: this.props.category ? this.props.category.id : null,
      world_id: this.props.world ? this.props.world.id : null,
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.world !== this.props.world ||
      nextProps.category !== this.props.category
    ) {
      this.props.unloadItemsICanGetFromOtherUser()
      this.props.loadItemsICanGetFromOtherUser({
        swapper_id: nextProps.swapperId,
        swap_id: nextProps.swapId,
        cat_id: nextProps.category ? nextProps.category.id : null,
        world_id: nextProps.world ? nextProps.world.id : null,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadItemsICanGetFromOtherUser()
  }

  loadMore = () => {
    this.props.loadMoreItemsICanGetFromOtherUser({
      swapper_id: this.props.swapperId,
      swap_id: this.props.swapId,
      cat_id: this.props.category ? this.props.category.id : null,
      world_id: this.props.world ? this.props.world.id : null,
    })
  }

  render() {
    const {
      items,
      loading,
      canLoadMoreItems,
      choosedItemsById,
      addItem,
      removeItem,
    } = this.props

    return (
      <ListItemsModal
        items={items}
        loading={loading}
        canLoadMoreItems={canLoadMoreItems}
        choosedItemsById={choosedItemsById}
        addItem={addItem}
        removeItem={removeItem}
        loadMore={this.loadMore}
      />
    )
  }
}

const mapStateToProps = state => ({
  items: getItemsICanGetFromOtherUser(state),
  totalItems: getTotalItemsICanGetFromOtherUser(state),
  canLoadMoreItems: canLoadMoreItemsICanGetFromOtherUser(state),
  loading: getItemsICanGetFromOtherUserLoading(state),
})

const ItemsICanGetModalListConnected = connect(mapStateToProps, {
  loadItemsICanGetFromOtherUser,
  loadMoreItemsICanGetFromOtherUser,
  unloadItemsICanGetFromOtherUser,
})(ItemsICanGetModalList)

const ItemsICanGetModal = ({
  open,
  onRequestClose,
  swapperId,
  swapId,
  choosedItemsById,
  addItem,
  removeItem,
}) => (
  <ItemsModal open={open} onRequestClose={onRequestClose}>
    <ItemsICanGetModalListConnected
      swapperId={swapperId}
      swapId={swapId}
      choosedItemsById={choosedItemsById}
      addItem={addItem}
      removeItem={removeItem}
    />
  </ItemsModal>
)

export default ItemsICanGetModal



// WEBPACK FOOTER //
// ./src/common/Swap/ItemsICanGetModal.js